'use client';

import { c as _c } from "react/compiler-runtime";
import type { NegociacaoCasoDetail } from '../../../types/negociacaoDetailTypes';
import type { ChatMessageUi, IaStatusUi, LastMensagemUi, NegotiationDetails, SituacaoAtualUi } from '../../../types/negociacaoDetailUiTypes';
import { selecionarParametrosDestacados } from '../../../utils/parametrosDestacados';
import { Badge, Button } from '@/shared/components/ui';
import { FeatherAlertCircle, FeatherClock, FeatherLoader, FeatherMessageSquare, FeatherSparkles } from '@subframe/core';
import { TemperaturaInfoPopover } from './TemperaturaInfoPopover';
interface NegociacaoAcompanhamentoProps {
  negotiation: NegotiationDetails;
  caso: NegociacaoCasoDetail;
  chatMessages: ChatMessageUi[];
  lastMensagemUi: LastMensagemUi;
  situacaoAtualUi: SituacaoAtualUi;
  iaStatusUi: IaStatusUi;
  isLoadingAiInsights: boolean;
  aiInsightsError: string | null;
  getTemperatureColorClass: (temperature: string) => string;
  onOpenChatTab: () => void;
  onOpenTimelineTab: () => void;
  onOpenDetails: () => void;
}
export function NegociacaoAcompanhamento(t0) {
  const $ = _c(124);
  const {
    negotiation,
    caso,
    chatMessages,
    lastMensagemUi,
    situacaoAtualUi,
    iaStatusUi,
    isLoadingAiInsights,
    aiInsightsError,
    getTemperatureColorClass,
    onOpenChatTab,
    onOpenTimelineTab,
    onOpenDetails
  } = t0;
  let mensagensRecentes;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== caso.start?.agentInput || $[1] !== chatMessages || $[2] !== getTemperatureColorClass || $[3] !== iaStatusUi.title || $[4] !== negotiation.agent || $[5] !== negotiation.channel || $[6] !== negotiation.client || $[7] !== negotiation.confidence || $[8] !== negotiation.confidenceLevel || $[9] !== negotiation.temperature || $[10] !== onOpenDetails || $[11] !== onOpenTimelineTab || $[12] !== situacaoAtualUi.iconBgClass || $[13] !== situacaoAtualUi.iconTextClass || $[14] !== situacaoAtualUi.message) {
    const parametrosDestacados = selecionarParametrosDestacados(caso.start?.agentInput ?? null);
    mensagensRecentes = chatMessages.slice(-2).reverse();
    t7 = "flex w-full flex-col gap-4";
    let t10;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <h2 id="negociacao-dados-essenciais" className="text-body-bold font-body-bold">Dados essenciais</h2>;
      $[25] = t10;
    } else {
      t10 = $[25];
    }
    let t11;
    if ($[26] !== onOpenDetails) {
      t11 = <div className="mb-2 flex flex-wrap items-center justify-between gap-2 px-1">{t10}<Button variant="neutral-tertiary" size="small" className="min-[1280px]:hidden" onClick={onOpenDetails}>Mais detalhes</Button></div>;
      $[26] = onOpenDetails;
      $[27] = t11;
    } else {
      t11 = $[27];
    }
    const t12 = `grid grid-cols-2 gap-x-3 gap-y-2 rounded-[16px] border border-solid border-neutral-200 bg-white p-3 sm:px-4 sm:py-3 ${parametrosDestacados.length === 0 ? "lg:grid-cols-3" : "lg:grid-cols-4"}`;
    let t13;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <span className="text-caption text-subtext-color">Contraparte</span>;
      $[28] = t13;
    } else {
      t13 = $[28];
    }
    let t14;
    if ($[29] !== negotiation.client) {
      t14 = <div className="min-w-0">{t13}<p className="text-default-font mt-0.5 text-[14px] leading-5 font-semibold break-words">{negotiation.client}</p></div>;
      $[29] = negotiation.client;
      $[30] = t14;
    } else {
      t14 = $[30];
    }
    const t15 = parametrosDestacados.map(_temp);
    let t16;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <span className="text-caption text-subtext-color">Canal ativo</span>;
      $[31] = t16;
    } else {
      t16 = $[31];
    }
    let t17;
    if ($[32] !== negotiation.channel) {
      t17 = <div className="min-w-0">{t16}<p className="mt-0.5 text-[13px] leading-[18px] font-medium break-words">{negotiation.channel}</p></div>;
      $[32] = negotiation.channel;
      $[33] = t17;
    } else {
      t17 = $[33];
    }
    let t18;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = <span className="text-caption text-subtext-color">Agente responsável</span>;
      $[34] = t18;
    } else {
      t18 = $[34];
    }
    let t19;
    if ($[35] !== negotiation.agent) {
      t19 = <div className="min-w-0">{t18}<p className="mt-0.5 text-[13px] leading-[18px] font-medium break-words">{negotiation.agent}</p></div>;
      $[35] = negotiation.agent;
      $[36] = t19;
    } else {
      t19 = $[36];
    }
    let t20;
    if ($[37] !== t12 || $[38] !== t14 || $[39] !== t15 || $[40] !== t17 || $[41] !== t19) {
      t20 = <div className={t12}>{t14}{t15}{t17}{t19}</div>;
      $[37] = t12;
      $[38] = t14;
      $[39] = t15;
      $[40] = t17;
      $[41] = t19;
      $[42] = t20;
    } else {
      t20 = $[42];
    }
    if ($[43] !== t11 || $[44] !== t20) {
      t8 = <section aria-labelledby="negociacao-dados-essenciais">{t11}{t20}</section>;
      $[43] = t11;
      $[44] = t20;
      $[45] = t8;
    } else {
      t8 = $[45];
    }
    let t21;
    if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
      t21 = <span className="text-caption text-subtext-color">Situação atual</span>;
      $[46] = t21;
    } else {
      t21 = $[46];
    }
    const t22 = `${situacaoAtualUi.iconBgClass} ${situacaoAtualUi.iconTextClass} flex h-6 w-6 shrink-0 items-center justify-center rounded-full`;
    let t23;
    if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
      t23 = <FeatherAlertCircle className="h-3.5 w-3.5" />;
      $[47] = t23;
    } else {
      t23 = $[47];
    }
    let t24;
    if ($[48] !== t22) {
      t24 = <span className={t22}>{t23}</span>;
      $[48] = t22;
      $[49] = t24;
    } else {
      t24 = $[49];
    }
    let t25;
    if ($[50] !== situacaoAtualUi.message) {
      t25 = <p className="text-[13px] leading-[18px] font-medium break-words">{situacaoAtualUi.message}</p>;
      $[50] = situacaoAtualUi.message;
      $[51] = t25;
    } else {
      t25 = $[51];
    }
    let t26;
    if ($[52] !== t24 || $[53] !== t25) {
      t26 = <div className="col-span-2 min-w-0 rounded-[16px] border border-solid border-neutral-200 bg-white p-3 lg:col-span-1">{t21}<div className="mt-1 flex items-start gap-2">{t24}{t25}</div></div>;
      $[52] = t24;
      $[53] = t25;
      $[54] = t26;
    } else {
      t26 = $[54];
    }
    let t27;
    if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
      t27 = <span className="text-caption text-subtext-color">Temperatura</span>;
      $[55] = t27;
    } else {
      t27 = $[55];
    }
    let t28;
    if ($[56] !== negotiation.temperature) {
      t28 = <div className="flex items-center gap-1.5">{t27}<TemperaturaInfoPopover temperature={negotiation.temperature} /></div>;
      $[56] = negotiation.temperature;
      $[57] = t28;
    } else {
      t28 = $[57];
    }
    let t29;
    if ($[58] !== getTemperatureColorClass || $[59] !== negotiation.temperature) {
      t29 = getTemperatureColorClass(negotiation.temperature);
      $[58] = getTemperatureColorClass;
      $[59] = negotiation.temperature;
      $[60] = t29;
    } else {
      t29 = $[60];
    }
    const t30 = `mt-1 text-[13px] leading-[18px] font-semibold ${t29}`;
    let t31;
    if ($[61] !== negotiation.temperature || $[62] !== t30) {
      t31 = <p className={t30}>{negotiation.temperature}</p>;
      $[61] = negotiation.temperature;
      $[62] = t30;
      $[63] = t31;
    } else {
      t31 = $[63];
    }
    let t32;
    if ($[64] !== t28 || $[65] !== t31) {
      t32 = <div className="min-w-0 rounded-[16px] border border-solid border-neutral-200 bg-white p-3">{t28}{t31}</div>;
      $[64] = t28;
      $[65] = t31;
      $[66] = t32;
    } else {
      t32 = $[66];
    }
    let t33;
    if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
      t33 = <span className="text-caption text-subtext-color">Condução</span>;
      $[67] = t33;
    } else {
      t33 = $[67];
    }
    let t34;
    if ($[68] !== iaStatusUi.title) {
      t34 = <p className="mt-1 text-[13px] leading-[18px] font-semibold break-words">{iaStatusUi.title}</p>;
      $[68] = iaStatusUi.title;
      $[69] = t34;
    } else {
      t34 = $[69];
    }
    let t35;
    if ($[70] !== negotiation.confidence || $[71] !== negotiation.confidenceLevel) {
      t35 = <p className="text-caption text-subtext-color mt-0.5 break-words">Confiança da IA: {negotiation.confidence}% ({negotiation.confidenceLevel})</p>;
      $[70] = negotiation.confidence;
      $[71] = negotiation.confidenceLevel;
      $[72] = t35;
    } else {
      t35 = $[72];
    }
    let t36;
    if ($[73] !== t34 || $[74] !== t35) {
      t36 = <div className="min-w-0 rounded-[16px] border border-solid border-neutral-200 bg-white p-3">{t33}{t34}{t35}</div>;
      $[73] = t34;
      $[74] = t35;
      $[75] = t36;
    } else {
      t36 = $[75];
    }
    if ($[76] !== t26 || $[77] !== t32 || $[78] !== t36) {
      t9 = <section aria-label={"Estado da negocia\xE7\xE3o"} className="grid grid-cols-2 gap-2 lg:grid-cols-[1.3fr_1fr_1fr]">{t26}{t32}{t36}</section>;
      $[76] = t26;
      $[77] = t32;
      $[78] = t36;
      $[79] = t9;
    } else {
      t9 = $[79];
    }
    t6 = "grid grid-cols-1 items-start gap-4 lg:grid-cols-2";
    t3 = "negociacao-jornada";
    t4 = "min-w-0 rounded-[16px] border border-solid border-neutral-200 bg-white p-4 sm:p-5";
    let t37;
    if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
      t37 = <h2 id="negociacao-jornada" className="text-body-bold font-body-bold">Jornada recente</h2>;
      $[80] = t37;
    } else {
      t37 = $[80];
    }
    if ($[81] !== onOpenTimelineTab) {
      t5 = <div className="flex flex-wrap items-center justify-between gap-2 border-b border-solid border-neutral-100 pb-3">{t37}<Button variant="neutral-tertiary" size="small" onClick={onOpenTimelineTab}>Ver linha do tempo completa</Button></div>;
      $[81] = onOpenTimelineTab;
      $[82] = t5;
    } else {
      t5 = $[82];
    }
    t1 = "mt-4 flex flex-col gap-4";
    t2 = mensagensRecentes.map(_temp2);
    $[0] = caso.start?.agentInput;
    $[1] = chatMessages;
    $[2] = getTemperatureColorClass;
    $[3] = iaStatusUi.title;
    $[4] = negotiation.agent;
    $[5] = negotiation.channel;
    $[6] = negotiation.client;
    $[7] = negotiation.confidence;
    $[8] = negotiation.confidenceLevel;
    $[9] = negotiation.temperature;
    $[10] = onOpenDetails;
    $[11] = onOpenTimelineTab;
    $[12] = situacaoAtualUi.iconBgClass;
    $[13] = situacaoAtualUi.iconTextClass;
    $[14] = situacaoAtualUi.message;
    $[15] = mensagensRecentes;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    mensagensRecentes = $[15];
    t1 = $[16];
    t2 = $[17];
    t3 = $[18];
    t4 = $[19];
    t5 = $[20];
    t6 = $[21];
    t7 = $[22];
    t8 = $[23];
    t9 = $[24];
  }
  let t10;
  if ($[83] !== lastMensagemUi || $[84] !== mensagensRecentes.length) {
    t10 = mensagensRecentes.length === 0 && lastMensagemUi.temMensagem && <li className="flex min-w-0 gap-3"><span className="bg-brand-50 text-brand-700 flex h-7 w-7 shrink-0 items-center justify-center rounded-full"><FeatherMessageSquare className="h-4 w-4" /></span><div className="min-w-0 flex-1 border-b border-solid border-neutral-100 pb-3"><div className="flex flex-wrap items-center justify-between gap-2"><span className="text-caption-bold font-caption-bold break-words">Mensagem · {lastMensagemUi.sender}</span><span className="text-caption text-subtext-color">{lastMensagemUi.time}</span></div><p data-dd-privacy="mask" className="text-caption text-subtext-color mt-1 line-clamp-2 break-words">{lastMensagemUi.preview}</p><div className="mt-2"><Badge variant={lastMensagemUi.badgeVariant}>{lastMensagemUi.badgeLabel}</Badge></div></div></li>;
    $[83] = lastMensagemUi;
    $[84] = mensagensRecentes.length;
    $[85] = t10;
  } else {
    t10 = $[85];
  }
  let t11;
  if ($[86] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-neutral-100 text-neutral-600"><FeatherClock className="h-4 w-4" /></span>;
    $[86] = t11;
  } else {
    t11 = $[86];
  }
  let t12;
  if ($[87] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span className="text-caption-bold font-caption-bold">Negociação criada</span>;
    $[87] = t12;
  } else {
    t12 = $[87];
  }
  let t13;
  if ($[88] !== negotiation.createdAt) {
    t13 = <li className="flex min-w-0 gap-3">{t11}<div className="flex min-w-0 flex-1 flex-wrap items-center justify-between gap-2">{t12}<span className="text-caption text-subtext-color">{negotiation.createdAt}</span></div></li>;
    $[88] = negotiation.createdAt;
    $[89] = t13;
  } else {
    t13 = $[89];
  }
  let t14;
  if ($[90] !== t1 || $[91] !== t10 || $[92] !== t13 || $[93] !== t2) {
    t14 = <ol className={t1}>{t2}{t10}{t13}</ol>;
    $[90] = t1;
    $[91] = t10;
    $[92] = t13;
    $[93] = t2;
    $[94] = t14;
  } else {
    t14 = $[94];
  }
  let t15;
  if ($[95] !== mensagensRecentes.length || $[96] !== onOpenChatTab) {
    t15 = mensagensRecentes.length > 0 && <Button variant="neutral-secondary" size="small" className="mt-4" onClick={onOpenChatTab}>Abrir conversa</Button>;
    $[95] = mensagensRecentes.length;
    $[96] = onOpenChatTab;
    $[97] = t15;
  } else {
    t15 = $[97];
  }
  let t16;
  if ($[98] !== t14 || $[99] !== t15 || $[100] !== t3 || $[101] !== t4 || $[102] !== t5) {
    t16 = <section aria-labelledby={t3} className={t4}>{t5}{t14}{t15}</section>;
    $[98] = t14;
    $[99] = t15;
    $[100] = t3;
    $[101] = t4;
    $[102] = t5;
    $[103] = t16;
  } else {
    t16 = $[103];
  }
  let t17;
  if ($[104] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <span className="bg-brand-50 text-brand-700 flex h-7 w-7 shrink-0 items-center justify-center rounded-[8px]"><FeatherSparkles className="h-4 w-4" /></span>;
    $[104] = t17;
  } else {
    t17 = $[104];
  }
  let t18;
  if ($[105] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="flex items-start gap-2">{t17}<div className="min-w-0"><h2 id="negociacao-analise-ia" className="text-body-bold font-body-bold">Análise estratégica da IA</h2><p className="text-caption text-subtext-color mt-1">Plano atual, motivos e sinais que podem mudar a abordagem.</p></div></div>;
    $[105] = t18;
  } else {
    t18 = $[105];
  }
  let t19;
  if ($[106] !== aiInsightsError) {
    t19 = aiInsightsError && <div className="text-error-700 flex items-start gap-2"><FeatherAlertCircle className="h-4 w-4 shrink-0" /><p className="text-caption">{aiInsightsError}</p></div>;
    $[106] = aiInsightsError;
    $[107] = t19;
  } else {
    t19 = $[107];
  }
  let t20;
  if ($[108] !== aiInsightsError || $[109] !== isLoadingAiInsights || $[110] !== negotiation.strategy) {
    t20 = negotiation.strategy ? <div className="flex flex-col"><div className="min-w-0 pb-3"><span className="text-caption text-subtext-color">Plano atual da negociação</span><p className="text-caption mt-1 break-words">{negotiation.strategy.currentPlan}</p></div><div className="min-w-0 border-t border-solid border-neutral-100 py-3"><span className="text-caption text-subtext-color">Por que esse plano faz sentido agora</span><p className="text-caption mt-1 break-words">{negotiation.strategy.rationale}</p></div><div className="min-w-0 border-t border-solid border-neutral-100 pt-3"><span className="text-caption text-subtext-color">O que faria a IA mudar de estratégia</span><p className="text-caption mt-1 break-words">{negotiation.strategy.strategyShiftTriggers}</p></div></div> : isLoadingAiInsights ? <div className="text-caption text-subtext-color flex items-center gap-2"><FeatherLoader className="h-4 w-4 animate-spin" />Gerando análise estratégica da IA.</div> : !aiInsightsError ? <p className="text-caption text-subtext-color">A análise estratégica será exibida quando houver contexto suficiente.</p> : null;
    $[108] = aiInsightsError;
    $[109] = isLoadingAiInsights;
    $[110] = negotiation.strategy;
    $[111] = t20;
  } else {
    t20 = $[111];
  }
  let t21;
  if ($[112] !== t19 || $[113] !== t20) {
    t21 = <section aria-labelledby="negociacao-analise-ia" className="min-w-0 rounded-[16px] border border-solid border-neutral-200 bg-white p-4 sm:p-5">{t18}<div className="mt-4 border-t border-solid border-neutral-100 pt-4">{t19}{t20}</div></section>;
    $[112] = t19;
    $[113] = t20;
    $[114] = t21;
  } else {
    t21 = $[114];
  }
  let t22;
  if ($[115] !== t16 || $[116] !== t21 || $[117] !== t6) {
    t22 = <div className={t6}>{t16}{t21}</div>;
    $[115] = t16;
    $[116] = t21;
    $[117] = t6;
    $[118] = t22;
  } else {
    t22 = $[118];
  }
  let t23;
  if ($[119] !== t22 || $[120] !== t7 || $[121] !== t8 || $[122] !== t9) {
    t23 = <div className={t7}>{t8}{t9}{t22}</div>;
    $[119] = t22;
    $[120] = t7;
    $[121] = t8;
    $[122] = t9;
    $[123] = t23;
  } else {
    t23 = $[123];
  }
  return t23;
}
function _temp2(mensagem) {
  return <li key={mensagem.id} className="flex min-w-0 gap-3"><span className="bg-brand-50 text-brand-700 flex h-7 w-7 shrink-0 items-center justify-center rounded-full"><FeatherMessageSquare className="h-4 w-4" /></span><div className="min-w-0 flex-1 border-b border-solid border-neutral-100 pb-3 last:border-b-0"><div className="flex flex-wrap items-center justify-between gap-2"><span className="text-caption-bold font-caption-bold break-words">Mensagem · {mensagem.sender}</span><span className="text-caption text-subtext-color">{mensagem.time}</span></div>{mensagem.text.trim() && <p data-dd-privacy="mask" className="text-caption text-subtext-color mt-1 line-clamp-2 break-words whitespace-pre-wrap">{mensagem.text}</p>}</div></li>;
}
function _temp(t0) {
  const {
    key,
    label,
    value
  } = t0;
  return <div key={key} className="min-w-0"><span className="text-caption text-subtext-color">{label}</span><p className="mt-0.5 text-[13px] leading-[18px] font-medium break-words">{value}</p></div>;
}